import { FC, ReactNode } from "react";

import { Question } from "capitalrx-types";
import { Stack } from "capitalrx-components-2.0/lib/layout";

import { QuestionPathStatus } from "@/utils";

import { GenerateQuestion } from "./GenerateQuestion";
import styles from "../../ClinicalCriteria.module.scss";


interface Props {
  readonly questions: ReadonlyArray<Question>;
  readonly allQuestions: ReadonlyArray<Question>;
  readonly questionnaireId: number;
  readonly isReadonly: boolean;
  readonly isPreview?: boolean;
  readonly debugMode?: boolean;
  readonly questionStatus: { [key: string]: QuestionPathStatus };
}

export const QuestionsSection: FC<Props> = ({
  debugMode,
  questions,
  questionnaireId,
  isReadonly,
  isPreview,
  allQuestions,
  questionStatus,
}) => {
  const components: ReactNode[] = [];

  let currentIndex = 0;
  while (currentIndex < questions.length) {
    const question = questions[currentIndex];
    const status = questionStatus[question.question_id];
    if (status == "not_applicable") {
      const notApplicableQuestions = [];
      while (currentIndex < questions.length) {
        const question = questions[currentIndex];
        const status = questionStatus[question.question_id];
        if (status != "not_applicable") {
          break;
        }
        notApplicableQuestions.push(question);
        currentIndex++;
      }
    } else {
      components.push(
        <GenerateQuestion
          key={question.question_id}
          question={question}
          idx={allQuestions.indexOf(question) + 1}
          questionnaireId={questionnaireId}
          isReadonly={isReadonly}
          isPreview={isPreview}
          debugMode={debugMode}
          questionPathStatus={questionStatus[question.question_id]}
        />,
      );
      currentIndex++;
    }
  }

  return (
    <Stack spacing="large" testId="question_items" className={styles.FullWidth}>
      {components}
    </Stack>
  );
};
